@if (control) {
  <p
    class="form-text ba-error"
    role="alert"
    [id]="getErrorMessageId()"
    [attr.aria-label]="hasError? control?.errors['message'] : '' | translate">
    {{ control?.errors['message'] | translate }}
  </p>
}
